var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 513,
    viewBox: "0 0 366 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 29.28H117.12V43.92H248.88V29.28Z",
    fill: "#2C5F2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 43.9199H102.48V58.5599H263.52V43.9199Z",
    fill: "#2C5F2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.48 58.5601H87.84V87.8401H102.48V58.5601Z",
    fill: "#2C5F2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.84 87.8401H73.2V131.76H87.84V87.8401Z",
    fill: "#2C5F2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.48 131.76H87.84V190.32H102.48V131.76Z",
    fill: "#2C5F2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.12 190.32H102.48V263.52H117.12V190.32Z",
    fill: "#2C5F2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.76 263.52H117.12V322.08H131.76V263.52Z",
    fill: "#2C5F2D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 322.08H131.76V366H146.4V322.08Z",
    fill: "#2C5F2D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.68 366H146.4V380.64H175.68V366Z",
    fill: "#2C5F2D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M204.96 380.64H175.68V395.28H204.96V380.64Z",
    fill: "#2C5F2D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 366H204.96V380.64H234.24V366Z",
    fill: "#2C5F2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 351.36H234.24V366H248.88V351.36Z",
    fill: "#2C5F2D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 322.08H248.88V351.36H263.52V322.08Z",
    fill: "#2C5F2D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.16 278.16H263.52V322.08H278.16V278.16Z",
    fill: "#2C5F2D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M278.16 234.24H263.52V278.16H278.16V234.24Z",
    fill: "#2C5F2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 190.32H248.88V234.24H263.52V190.32Z",
    fill: "#2C5F2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 146.4H234.24V190.32H248.88V146.4Z",
    fill: "#2C5F2D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 117.12H248.88V146.4H263.52V117.12Z",
    fill: "#2C5F2D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.16 87.8401H263.52V117.12H278.16V87.8401Z",
    fill: "#2C5F2D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 58.5601H248.88V87.8401H263.52V58.5601Z",
    fill: "#2C5F2D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 43.9199H117.12V58.5599H248.88V43.9199Z",
    fill: "#4A9D4F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 58.5598H102.48V73.1998H248.88V58.5598Z",
    fill: "#4A9D4F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 73.2H87.84V87.84H248.88V73.2Z",
    fill: "#4A9D4F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 87.8398H73.2V117.12H248.88V87.8398Z",
    fill: "#4A9D4F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 117.12H87.84V131.76H248.88V117.12Z",
    fill: "#4A9D4F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 131.76H87.84V146.4H234.24V131.76Z",
    fill: "#4A9D4F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 146.4H102.48V190.32H234.24V146.4Z",
    fill: "#4A9D4F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 190.32H102.48V234.24H248.88V190.32Z",
    fill: "#4A9D4F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 234.24H117.12V263.52H263.52V234.24Z",
    fill: "#4A9D4F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 263.52H117.12V278.16H248.88V263.52Z",
    fill: "#4A9D4F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 278.16H117.12V322.08H263.52V278.16Z",
    fill: "#4A9D4F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 322.08H131.76V351.36H248.88V322.08Z",
    fill: "#4A9D4F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 351.36H131.76V366H234.24V351.36Z",
    fill: "#4A9D4F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M204.96 366H146.4V380.64H204.96V366Z",
    fill: "#4A9D4F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 43.9199H117.12V58.5599H161.04V43.9199Z",
    fill: "#6BC96F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 58.5598H102.48V73.1998H161.04V58.5598Z",
    fill: "#6BC96F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 73.2H87.84V87.84H161.04V73.2Z",
    fill: "#6BC96F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 87.8398H73.2V117.12H146.4V87.8398Z",
    fill: "#5FB863"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 117.12H87.84V146.4H146.4V117.12Z",
    fill: "#5FB863"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 146.4H102.48V190.32H146.4V146.4Z",
    fill: "#5FB863"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 58.5601H219.6V73.2001H248.88V58.5601Z",
    fill: "#3D8841"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 87.8401H219.6V117.12H248.88V87.8401Z",
    fill: "#3D8841"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 117.12H204.96V146.4H234.24V117.12Z",
    fill: "#3D8841"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 190.32H219.6V234.24H248.88V190.32Z",
    fill: "#3D8841"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 234.24H234.24V278.16H263.52V234.24Z",
    fill: "#3D8841"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M263.52 278.16H234.24V322.08H263.52V278.16Z",
    fill: "#3D8841"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M248.88 322.08H219.6V351.36H248.88V322.08Z",
    fill: "#3D8841"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 351.36H204.96V366H234.24V351.36Z",
    fill: "#3D8841"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 409.92H117.12V424.56H161.04V409.92Z",
    fill: "#2C5F2D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 424.56H117.12V439.2H161.04V424.56Z",
    fill: "#4A9D4F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M131.76 424.56H117.12V439.2H131.76V424.56Z",
    fill: "#6BC96F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 424.56H146.4V439.2H161.04V424.56Z",
    fill: "#3D8841"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 161.04H131.76V175.68H161.04V161.04Z",
    fill: "#E74C3C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 175.68H131.76V190.32H161.04V175.68Z",
    fill: "#FF6B5A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 175.68H146.4V190.32H161.04V175.68Z",
    fill: "#FFA599"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M161.04 190.32H146.4V204.96H161.04V190.32Z",
    fill: "#C0392B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 322.08H219.6V336.72H234.24V322.08Z",
    fill: "#E74C3C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 336.72H219.6V351.36H234.24V336.72Z",
    fill: "#C0392B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4 409.92H131.76V424.56H146.4V409.92Z",
    fill: "#E74C3C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M204.96 58.5598H175.68V73.1998H204.96V58.5598Z",
    fill: "#8B7355"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M204.96 43.9199H190.32V58.5599H204.96V43.9199Z",
    fill: "#A0876F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 161.04H204.96V175.68H234.24V161.04Z",
    fill: "#8B7355"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 146.4H219.6V161.04H234.24V146.4Z",
    fill: "#A0876F"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 204.96H204.96V219.6H234.24V204.96Z",
    fill: "#8B7355"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 190.32H219.6V204.96H234.24V190.32Z",
    fill: "#A0876F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 248.88H204.96V263.52H234.24V248.88Z",
    fill: "#8B7355"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M190.32 219.6H161.04V234.24H190.32V219.6Z",
    fill: "#8B7355"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M190.32 204.96H175.68V219.6H190.32V204.96Z",
    fill: "#A0876F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M204.96 175.68H161.04V183H204.96V175.68Z",
    fill: "#3498DB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M219.6 183H190.32V190.32H219.6V183Z",
    fill: "#3498DB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M212.28 219.6H204.96V263.52H212.28V219.6Z",
    fill: "#3498DB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M226.92 263.52H212.28V270.84H226.92V263.52Z",
    fill: "#3498DB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M226.92 270.84H219.6V314.76H226.92V270.84Z",
    fill: "#3498DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.192b6dde4af3d9003c0ee8b54645fdf7.svg";
export { ForwardRef as ReactComponent };